import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { IonApp, IonRouterOutlet } from '@ionic/vue';
    import { onMounted } from 'vue';
    import { LoadingProvider } from './components/ui/feedback';
    import FraudAlertModal from './components/ui/modals/FraudAlertModal.vue';
    import MobileSidePanel from './components/ui/navigation/MobileSidePanel.vue';
    import { useAppInit } from './composables/useAppInit';
    import { useAuthStore } from './store/auth';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const { initializeApp } = useAppInit();
    const authStore = useAuthStore();

    onMounted(async () => {
        await initializeApp();
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(LoadingProvider)),
      _createVNode(FraudAlertModal),
      (_unref(authStore).isAuthenticated && !_unref(authStore).isInVerificationProcess)
        ? (_openBlock(), _createBlock(MobileSidePanel, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonRouterOutlet), {
        id: "main-content",
        animated: "false"
      })
    ]),
    _: 1
  }))
}
}

})